<script>
  import { onMount } from "svelte";
  import {
    addHash,
    decorateProject,
    localeOrderBy,
    slice,
    loadPersisted,
    savePersisted,
  } from "../../mjnUtils";
  import Pagination from "./pagination/Pagination.svelte";

  let { http, toastr, search } = $props();

  let projects = $state([]);
  let members = $state([]);
  let searchText = $state("");
  let sortType = $state(loadPersisted("projects", "sortType", "stamp"));
  let sortReverse = $state(loadPersisted("projects", "sortReverse", true));
  let currentPage = $state(1);
  const itemsPerPage = 11;

  $effect(() => {
    savePersisted("projects", "sortType", sortType);
    savePersisted("projects", "sortReverse", sortReverse);
  });

  onMount(() => {
    Promise.all([http.get("/api/projekt.php"), http.get("/api/czlonek.php")]).then(
      ([projectsResponse, membersResponse]) => {
        if (
          projectsResponse.data.status == 200 &&
          membersResponse.data.status == 200
        ) {
          members = addHash(membersResponse.data.records, "idcz");
          const loadedProjects = addHash(projectsResponse.data.records, "idpr");
          loadedProjects.forEach((project) => decorateProject(project, members));
          projects = loadedProjects;
        } else {
          toastr.error(
            "Błąd: " +
              projectsResponse.data.message +
              membersResponse.data.message,
          );
        }
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  });

  let filteredProjects = $derived(search(projects, searchText));
  let sortedProjects = $derived(localeOrderBy(filteredProjects, sortType, sortReverse));
  let totalItems = $derived(filteredProjects.length);
  let numPages = $derived(Math.max(1, Math.ceil(totalItems / itemsPerPage)));
  let pagedProjects = $derived(slice(sortedProjects, itemsPerPage, currentPage));

  $effect(() => {
    searchText;
    currentPage = 1;
  });

  function setSort(field) {
    if (sortType === field) {
      sortReverse = !sortReverse;
    } else {
      sortType = field;
      sortReverse = false;
    }
  }
</script>

<h3><i class="fas fa-funnel-dollar fa-lg"></i>&nbsp;&nbsp;Projekty
<div class="btn-toolbar pull-right">
    <a class="btn btn-primary btn-sm pull-right" href="/project-edit/-1" title="Przejście do karty edycji, na której wpisujemy dane nowego Projecku."><i class="fas fa-plus" aria-hidden="true"></i>
        <span class="hidden-xs">&nbsp;Dodaj nowy projekt...</span></a>
</div>
</h3>
<div class="clearfix"></div>
<div class="text-left"><small><i class="fas fa-random" aria-hidden="true"></i>
W tej chwili mamy {projects.length} zdefiniowanych projektów{#if searchText != ""}, {filteredProjects.length} przefiltrowanych poniżej{/if}.
</small><p></p></div>

<form>
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-addon"><i class="fas fa-search"></i></div>
        <input type="text" class="form-control input-sm" placeholder="Wyszukaj projekt" bind:value={searchText}>
      </div>
    </div>
</form>

<table class="table table-condensed table-hover table-striped">

    <thead class="thead-default">
      <tr>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("nazwa"); }}>
          Nazwa
          {#if sortType == "nazwa" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "nazwa" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("data_od"); }}>
          Okres
          {#if sortType == "data_od" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "data_od" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("kwota"); }}>
          Kwota
          {#if sortType == "kwota" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "kwota" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("koord_sort_text"); }}>
          Koordynacja
          {#if sortType == "koord_sort_text" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "koord_sort_text" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          Operacje
        </th>
      </tr>
    </thead>

    <tbody>
      {#each pagedProjects as project (project.idpr)}
      <tr>
        <td>
            <i class="fas fa-funnel-dollar fa-lg fa-fw" aria-hidden="true" style="margin: 6px 0px 8px 0px;"></i>&nbsp;&nbsp;
            <a href={"/project-detail/" + project.idpr} title="Podgląd danych">{project.nazwa}</a>
            <div class="small text-muted">
				<span><i class="fas fa-ellipsis-h fa-fw" aria-hidden="true"></i>{project.nazwa_dl}</span>
			</div>
        </td>
        <td>
            {project.data_od} - {project.data_do}
        </td>
        <td>
            {project.kwota} {project.waluta}
        </td>
        <td>
            <a href={"/member-detail/" + project.koord}>{project.koord_text}</a>
        </td>
        <td>
            <a href={"/project-detail/" + project.idpr} title="Podgląd danych"><i class="fas fa-eye fa-lg fa-fw"></i></a>
            <a href={"/project-detail/" + project.idpr} title="Edycja projektu"><i class="fas fa-pen-square fa-lg fa-fw"></i></a>
        </td>
      </tr>
      {/each}
    </tbody>

</table>

<Pagination {currentPage} {numPages} onPageChange={(page) => currentPage = page}/>
